import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

import { units } from '../../utils/spacing';
import { FontSize } from '../../utils/typography/types';
import { PaletteColor } from '../ThemeProvider';

export const StyledTrigger = styled.div<{ $isDisabled?: boolean }>`
	display: flex;
	${p => (p.$isDisabled ? '' : 'cursor: pointer;')}
	align-items: center;
	min-height: ${units(6)};
`;

/**
 * CollapsibleInner is just used to set display:none when collapsed
 * for accessibility reasons.
 * react-collapsible has this built in via prop contentHiddenWhenClosed
 * but that is broken as of the current version 2.10.0
 */
export const CollapsibleInner = styled.div<{ $isOpen: boolean }>`
	${p =>
		p.$isOpen
			? ''
			: css`
					display: none;
				`}
`;

export const IconContainer = styled.span<{
	$isOpen: boolean;
	$size: FontSize;
	$color: PaletteColor;
	$animationTimeMs: number;
}>`
	width: ${p => units(p.$size * 2)};
	height: ${p => units(p.$size * 2)};
	margin-right: ${units(1)};
	display: inline-flex;
	align-items: center;
	justify-content: center;

	svg {
		${p => `transition: transform ${p.$animationTimeMs / 1000}s ease`};
		${p => (p.$isOpen ? '' : 'transform: rotate(-90deg);')}

		width: ${p => units(p.$size * 2)};
		height: ${p => units(p.$size * 2)};

		path {
			width: 100%;
			height: 100%;
			fill: ${p => palette(p.$color)};
		}
	}
`;
